export const GOOGLE_MAPS_SERVICE_ID = 'S1pcEj_jZX';

function usercentricsApi(uc) {
    if (uc !== undefined) {
        return uc;
    }

    return typeof UC_UI === 'undefined' ? undefined : UC_UI;
}

export function isGoogleMapsConsented(services) {
    if (!Array.isArray(services)) {
        return false;
    }

    for (let index = 0; index < services.length; index += 1) {
        const service = services[index];
        const consent = service && service.consent;
        if (service && service.id === GOOGLE_MAPS_SERVICE_ID && consent && consent.status === true) {
            return true;
        }
    }

    return false;
}

export function readGoogleMapsConsent(uc) {
    const api = usercentricsApi(uc);
    if (!api || typeof api.getServicesBaseInfo !== 'function') {
        return false;
    }

    try {
        return isGoogleMapsConsented(api.getServicesBaseInfo());
    } catch (error) {
        return false;
    }
}

export async function grantGoogleMapsConsent(uc) {
    const api = usercentricsApi(uc);
    if (!api || typeof api.acceptService !== 'function') {
        return false;
    }

    try {
        await api.acceptService(GOOGLE_MAPS_SERVICE_ID);
    } catch (error) {
        return false;
    }

    return readGoogleMapsConsent(api);
}
